
import { Subscriber } from "../types";

const DB_KEY = 'artesano_subscribers_v1';

export const databaseService = {
  // Obtener todos los suscriptores
  getAllSubscribers: (): Subscriber[] => {
    const data = localStorage.getItem(DB_KEY);
    return data ? JSON.parse(data) : [];
  },

  // Añadir un nuevo suscriptor
  addSubscriber: (email: string, source: string = 'web'): { success: boolean, message: string } => {
    const subscribers = databaseService.getAllSubscribers();
    
    // Validación básica
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { success: false, message: 'Email no válido' };
    }

    // Verificar duplicados
    if (subscribers.find(s => s.email.toLowerCase() === email.toLowerCase())) {
      return { success: false, message: 'Este email ya está en nuestra base de datos' };
    }

    const newSubscriber: Subscriber = {
      id: crypto.randomUUID(),
      email: email.toLowerCase(),
      joinedAt: new Date().toISOString(),
      source
    };

    const updated = [newSubscriber, ...subscribers];
    localStorage.setItem(DB_KEY, JSON.stringify(updated));

    return { success: true, message: '¡Gracias por unirte a nuestra comunidad!' };
  },

  // Eliminar suscriptor
  removeSubscriber: (id: string): void => {
    const subscribers = databaseService.getAllSubscribers();
    const updated = subscribers.filter(s => s.id !== id);
    localStorage.setItem(DB_KEY, JSON.stringify(updated));
  },

  // Exportar datos
  exportToCSV: (): string => {
    const subscribers = databaseService.getAllSubscribers();
    if (subscribers.length === 0) return '';
    
    const headers = ['ID', 'Email', 'Fecha Registro', 'Origen'];
    const rows = subscribers.map(s => [s.id, s.email, s.joinedAt, s.source]);
    
    return [
      headers.join(','),
      ...rows.map(r => r.join(','))
    ].join('\n');
  }
};
